import React from 'react';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
//
import {DashboardIcon, PeopleIcon, BarChartIcon, CurrencyExchangeIcon} from 'components/common/icons';
import {PERMISSIONS} from '../../constants';

export const menu = [
  {
    icon: <DashboardIcon />,
    title: 'Clients',
    link: '/dashboard',
    permissions: [PERMISSIONS.CLIENTS_READ, PERMISSIONS.CLIENTS_MANAGEMENT],
    items: [],
  },
  {
    icon: <PublicOutlinedIcon />,
    title: 'Publishers',
    link: '/publishers',
    permissions: [PERMISSIONS.PUBLISHERS_READ, PERMISSIONS.PUBLISHERS_MANAGEMENT],
    items: [
      {
        icon: null,
        title: 'Publishers',
        link: '/publishers',
        items: [],
      },
      {
        icon: null,
        title: 'Endpoints',
        link: '/endpoints',
        items: [],
      },
    ],
  },
  {
    icon: <BarChartIcon />,
    title: 'Reports',
    link: '/reports',
    permissions: [PERMISSIONS.ANALYTICS_REPORT_READ, PERMISSIONS.BALANCES_REPORT_READ],
    items: [
      {
        icon: null,
        title: 'Analytics',
        link: '/reports/analytics',
        permissions: [PERMISSIONS.ANALYTICS_REPORT_READ],
        items: [],
        },
      {
        icon: null,
        title: 'Balances',
        link: '/reports/balances',
        permissions: [PERMISSIONS.BALANCES_REPORT_READ],
        items: [],
      },
    ],
  },
  {
    icon: <CurrencyExchangeIcon />,
    title: 'Transactions',
    link: '/transactions',
    permissions: [PERMISSIONS.TRANSACTIONS_READ, PERMISSIONS.TRANSACTIONS_MANAGEMENT],
    items: [
      {
        icon: null,
        title: 'Clients',
        link: '/transactions/clients',
        items: [],
      },
      {
        icon: null,
        title: 'Publishers',
        link: '/transactions/publishers',
        items: [],
      },
      {
        icon: null,
        title: 'Top Up Requests',
        link: '/transactions/top-up-requests',
        items: [],
      },
    ],
  },
  {
    icon: <PeopleIcon />,
    title: 'Users',
    link: '/users',
    permissions: [PERMISSIONS.USER_MANAGEMENT],
    items: [],
  },
];
